// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__uVyh_","importantInfo":"styles_importantInfo__D8U33"};